import application from 'application/application';

application.directive('ngMinValue', () => ({
	require: 'ngModel',
	scope: {
		ngMinValue: '='
	},
	link(scope, element, attrs, controller) {
		controller.$validators.MinValue = modelValue => {
			if (controller.$isEmpty(modelValue) || !scope.ngMinValue) return true;
			const value = modelValue.replace(/\D/g, '');

			return value >= scope.ngMinValue;
		};
	}
}));
